<template>
  <v-dialog
    v-model="changesDetected"
    persistent
    max-width="440"
  >
    <v-card>
      <v-card-title class="text-h5">
        Kohteen tietoja muokattu
      </v-card-title>
      <v-card-text class="pt-3 pb-0">
        <p v-if="currentProperty">
          Kohteen {{ typeHasChanged ? 'toimeksiantotyyppiä' : 'tietoja' }} on muokattu tämän
          sopimuksen luontiajankohdan
          <span class="primary--text">
            {{ createDate | date }}
            klo {{ createDate | date({ type: 'time' }) }}
          </span>
          jälkeen. Kohdetta on muokattu
          <span class="primary--text">
            {{ currentProperty.muokattu | date }} klo
            {{ currentProperty.muokattu | date({ type: 'time' }) }}
          </span>.
        </p>

        <v-alert
          v-if="typeHasChanged"
          type="warning"
          prominent
          text
        >
          Sinun tulee luoda sopimus uudelleen. Huom! Kaikki sopimukseen aiemmin tekemäsi muutokset
          häviävät.
        </v-alert>
        <v-alert
          v-else
          type="warning"
          prominent
          text
        >
          Päivitä tiedot ajantasaisiksi. Muita sopimukseen syöttämiäsi tietoja ei muuteta.
          Huom! Mikäli luot sopimuksen uudelleen, kaikki aiemmin tekemäsi muutokset
          häviävät.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          text
          @click="updateProperty"
        >
          Luo uudelleen
        </v-btn>
        <v-btn
          v-if="!typeHasChanged"
          color="primary"
          text
          @click="updateProperty"
        >
          Päivitä tiedot
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ChangesDetected',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    changesDetected: false,
    currentProperty: null,
  }),

  computed: {
    ...mapState({
      commissionAgreements: state => state.commissionAgreement.byId,
    }),
    createDate() {
      return this.commissionAgreements[this.id].created;
    },
    id() {
      return +this.$route.params.id;
    },
    typeHasChanged() {
      if (!this.currentProperty) return false;
      return (this.currentProperty.osakevaikiinteisto !== this.form.property.osakevaikiinteisto)
        || (this.currentProperty.onkovuokrakohde !== this.form.property.onkovuokrakohde);
    },
  },

  async mounted() {
    await this.detectChanges();
  },
  methods: {
    ...mapActions({
      createAgreement: 'commissionAgreement/create',
      getAgreement: 'commissionAgreement/getOne',
      getProperty: 'properties/getOne',
    }),
    async detectChanges() {
      this.currentProperty = await this.getProperty({ id: this.id });
      if (this.currentProperty.muokattu !== this.form.property.muokattu) {
        this.changesDetected = true;
      }
    },
    async updateProperty() {
      await this.$bus.$emit('POPULATE_COMMISSION_AGREEMENT');
      this.changesDetected = false;
    },
    async resetProperty() {
      this.$bus.$emit('RESET_COMMISSION_AGREEMENT');
      this.changesDetected = false;
    },
  },
};
</script>
